module.exports = __webpack_public_path__ + "img/technology.d6ba32ca.svg";